module.exports = require('./lib/psd');


//////////////////
// WEBPACK FOOTER
// ./index.js
// module id = 0
// module chunks = 0